fx.ns("shared.screens", class ThemeCategories extends shared.screens.BaseChoiceScreen 
{    
    constructor()
    {
        super();

        this.showNext = false;
        this.showBack = true;

        this.containerHeight = 500;

        this.title = fx.text("Quel type d'album souhaitez-vous créer?");
    }

    create()
    {
        super.create();

        if (this.data.themetags.length == 0)
        {
            this.loading(true, fx.text("Chargement"));
            this.data.getThemeTags();
        }
        else
            this.build();
    }

    onDataEvent(event)
    {
        if (event.type == "theme-tags-loaded")
            this.build();
    }

    build()
    {
        super.build();

        if (fx.browser.isDesktop)
        {
            this.hContainer.align = "left";
            this.hContainer.viewport({height : 600, width:840, left : "center"});
        }

        let themetags = this.data.themetags.filter(  tag => tag.id_lang == fx.service("LangService").current.id);
        let temetag = {id : 0, thumbnail : "/app/assets/images/album-vierge.png", tag : fx.text("Album Blanc"), background_color : '#FFFFFF' };
        themetags.unshift( temetag );

        for (let i = 0; i < themetags.length; i++)
        {
            let renderer = new shared.renderers.ThemeTagRenderer(themetags.getItemAt(i));

            if (this.data.choosedThemeTag && themetags.getItemAt(i).id == this.data.choosedThemeTag)
                    renderer.addClass("selected");

            renderer.css("backgroundColor", themetags.getItemAt(i).background_color);

            if (themetags.getItemAt(i).id == 0)
                renderer.addClass("white");

            renderer.attr("data-testid", "theme-category-" + i);

            this.addChoice(renderer, fx.browser.isDesktop ? {width : 260, height : 55} : {width : "90%", height : 70, left: "center"})
        }
        
        this.loading(false);
    }

    onClick(event)
    {
        let target = this.getChildFromUI(fx.dom.parent(event.target, ".ThemeTagRenderer"));
        
        if(target)
        {
            this.data.choosedThemeTag = target.data.id;
            this.data.event("next-step");
        }
    }


});
    
        